import {
    IWebsiteScorecardConfig, IWebsiteScorecardCategoryConfig
} from '../../../../_shared/models/models-index';
import * as constants from '../../../../_shared/constants/constants';

export class WebsiteScorecardConfig implements IWebsiteScorecardConfig {

    public reportTitle = 'Website Scorecard';
    public scorecards: IWebsiteScorecardCategoryConfig[] = [
        {
            category: 'Volume',
            billboards: [
                {
                    title: 'Visits',
                    subtitle: 'Previous MTD',
                    subtitleMetricPropertyName: 'totalVisitsPreviousMTD',
                    subtitleMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    iconClass: 'fa-user-o fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'totalVisits',
                    metricMOMPropertyName: 'totalVisitsMOM',
                    metricYOYPropertyName: 'totalVisitsYOY',
                    metricPreviousMonthPropertyName: 'totalVisitsPreviousMonth',
                    metricPreviousMTDPropertyName: 'totalVisitsPreviousMTD',
                    metricPreviousYearPropertyName: 'totalVisitsPreviousYear',
                    secondaryMetricPropertyName: 'dealerAvgTotalVisits',
                    secondaryMetricLabel: 'Dealer Avg',
                    secondaryMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    footerLeftLabel: 'MOM',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'totalVisitsMOM',
                    metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    helpTextKey: 'WebsiteScorecardTotalVisitsHelp',
                    helpTextTitle: 'Visits',
                    scoreCardCategory: 'Volume'
                },
                {
                    title: 'Unique Visits',
                    subtitle: 'Previous MTD',
                    subtitleMetricPropertyName: 'uniqueVisitsPreviousMTD',
                    subtitleMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    iconClass: 'fa-user-circle-o fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'uniqueVisits',
                    metricMOMPropertyName: 'uniqueVisitsMOM',
                    metricYOYPropertyName: 'uniqueVisitsYOY',
                    metricPreviousMonthPropertyName: 'uniqueVisitsPreviousMonth',
                    metricPreviousMTDPropertyName: 'uniqueVisitsPreviousMTD',
                    metricPreviousYearPropertyName: 'uniqueVisitsPreviousYear',
                    secondaryMetricPropertyName: 'dealerAvgUniqueVisits',
                    secondaryMetricLabel: 'Dealer Avg',
                    secondaryMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    footerLeftLabel: 'MOM',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'uniqueVisitsMOM',
                    metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    helpTextKey: 'WebsiteScorecardUniqueVisitsHelp',
                    helpTextTitle: 'Unique Visits',
                    scoreCardCategory: 'Volume'
                },
                {
                    title: 'Page Views',
                    subtitle: 'Previous MTD',
                    subtitleMetricPropertyName: 'pageViewsPreviousMTD',
                    subtitleMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    iconClass: 'fa-eye fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'pageViews',
                    metricMOMPropertyName: 'pageViewsMOM',
                    metricYOYPropertyName: 'pageViewsYOY',
                    metricPreviousMonthPropertyName: 'pageViewsPreviousMonth',
                    metricPreviousMTDPropertyName: 'pageViewsPreviousMTD',
                    metricPreviousYearPropertyName: 'pageViewsPreviousYear',
                    secondaryMetricPropertyName: 'dealerAvgPageViews',
                    secondaryMetricLabel: 'Dealer Avg',
                    secondaryMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    footerLeftLabel: 'MOM',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'pageViewsMOM',
                    metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    helpTextKey: 'WebsiteScorecardPageViewsHelp',
                    helpTextTitle: 'Page Views',
                    scoreCardCategory: 'Volume'
                }
            ],
        },
        {
            category: 'Engagement',
            billboards: [
                {
                    title: 'Engagement Rate',
                    subtitle: 'Previous MTD',
                    subtitleMetricPropertyName: 'engagementRatePreviousMTD',
                    subtitleMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    iconClass: 'fa-commenting-o fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'engagementRate',
                    metricMOMPropertyName: 'engagementRateMOM',
                    metricYOYPropertyName: 'engagementRateYOY',
                    metricPreviousMonthPropertyName: 'engagementRatePreviousMonth',
                    metricPreviousMTDPropertyName: 'engagementRatePreviousMTD',
                    metricPreviousYearPropertyName: 'engagementRatePreviousYear',
                    secondaryMetricPropertyName: 'dealerAvgEngagementRate',
                    secondaryMetricLabel: 'Dealer Avg',
                    secondaryMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    footerLeftLabel: 'MOM',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'engagementRateMOM',
                    metricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    helpTextKey: 'WebsiteScorecardEngagementRateHelp',
                    helpTextTitle: 'Engagement Rate',
                    scoreCardCategory: 'Engagements'
                },
                {
                    title: 'Avg. Time On Site',
                    subtitle: 'Previous MTD',
                    subtitleMetricPropertyName: 'averageTimeOnSitePreviousMTD',
                    subtitleMetricFormatKey: constants.formatKeys.minutesTimeStringFromSeconds,
                    iconClass: 'fa-clock-o fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'averageTimeOnSite',
                    metricMOMPropertyName: 'averageTimeOnSiteMOM',
                    metricYOYPropertyName: 'averageTimeOnSiteYOY',
                    metricPreviousMonthPropertyName: 'averageTimeOnSitePreviousMonth',
                    metricPreviousMTDPropertyName: 'averageTimeOnSitePreviousMTD',
                    metricPreviousYearPropertyName: 'averageTimeOnSitePreviousYear',
                    secondaryMetricPropertyName: 'dealerAvgAvgTimeOnSite',
                    secondaryMetricLabel: 'Dealer Avg',
                    secondaryMetricFormatKey: constants.formatKeys.minutesTimeStringFromSeconds,
                    footerLeftLabel: 'MOM',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'averageTimeOnSiteMOM',
                    metricFormatKey: constants.formatKeys.minutesTimeStringFromSeconds,
                    helpTextKey: 'WebsiteScorecardTimeOnSiteHelp',
                    helpTextTitle: 'Avg. Time On Site',
                    scoreCardCategory: 'Engagements'
                },
                {
                    title: 'VDP Views',
                    subtitle: 'Previous MTD',
                    subtitleMetricPropertyName: 'totalInventoryDetailViewsPreviousMTD',
                    subtitleMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    iconClass: 'fa-eye fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'totalInventoryDetailViews',
                    metricMOMPropertyName: 'totalInventoryDetailViewsMOM',
                    metricYOYPropertyName: 'totalInventoryDetailViewsYOY',
                    metricPreviousMonthPropertyName: 'totalInventoryDetailViewsPreviousMonth',
                    metricPreviousMTDPropertyName: 'totalInventoryDetailViewsPreviousMTD',
                    metricPreviousYearPropertyName: 'totalInventoryDetailViewsPreviousYear',
                    secondaryMetricPropertyName: 'dealerAvgVdpViews',
                    secondaryMetricLabel: 'Dealer Avg',
                    secondaryMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    footerLeftLabel: 'MOM',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'totalInventoryDetailViewsMOM',
                    metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    helpTextKey: 'WebsiteScorecardVDPViewsHelp',
                    helpTextTitle: 'VDP Views',
                    scoreCardCategory: 'Engagements'
                },
                {
                    title: 'Bounce Rate',
                    subtitle: 'Previous MTD',
                    subtitleMetricPropertyName: 'bounceRatePreviousMTD',
                    subtitleMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    iconClass: 'fa-commenting-o fa-primary',
                    reverseMetric: true,
                    metricCurrentPropertyName: 'bounceRate',
                    metricMOMPropertyName: 'bounceRateMOM',
                    metricYOYPropertyName: 'bounceRateYOY',
                    metricPreviousMonthPropertyName: 'bounceRatePreviousMonth',
                    metricPreviousMTDPropertyName: 'bounceRatePreviousMTD',
                    metricPreviousYearPropertyName: 'bounceRatePreviousYear',
                    secondaryMetricPropertyName: 'dealerAvgBounceRate',
                    secondaryMetricLabel: 'Dealer Avg',
                    secondaryMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    footerLeftLabel: 'MOM',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'bounceRateMOM',
                    metricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    helpTextKey: 'WebsiteScorecardBounceRateHelp',
                    helpTextTitle: 'Bounce Rate',
                    scoreCardCategory: 'Engagements'
                },
            ]
        },
        {
            category: 'Actions',
            billboards: [
                {
                    title: 'Action Rate',
                    subtitle: 'Previous MTD',
                    subtitleMetricPropertyName: 'actionRatePreviousMTD',
                    subtitleMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    iconClass: 'fa-files-o fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'actionRate',
                    metricMOMPropertyName: 'actionRateMOM',
                    metricYOYPropertyName: 'actionRateYOY',
                    metricPreviousMonthPropertyName: 'actionRatePreviousMonth',
                    metricPreviousMTDPropertyName: 'actionRatePreviousMTD',
                    metricPreviousYearPropertyName: 'actionRatePreviousYear',
                    secondaryMetricPropertyName: 'dealerAvgActionRate',
                    secondaryMetricLabel: 'Dealer Avg',
                    secondaryMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    footerLeftLabel: 'MOM',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'actionRateMOM',
                    metricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    helpTextKey: 'WebsiteScorecardActionRateHelp',
                    helpTextTitle: 'Action Rate',
                    scoreCardCategory: 'Actions'
                },
                {
                    title: 'Form Submissions',
                    subtitle: 'Previous MTD',
                    subtitleMetricPropertyName: 'formSubmissionsPreviousMTD',
                    subtitleMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    iconClass: 'fa-file-text-o fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'formSubmissions',
                    metricMOMPropertyName: 'formSubmissionsMOM',
                    metricYOYPropertyName: 'formSubmissionsYOY',
                    metricPreviousMonthPropertyName: 'formSubmissionsPreviousMonth',
                    metricPreviousMTDPropertyName: 'formSubmissionsPreviousMTD',
                    metricPreviousYearPropertyName: 'formSubmissionsPreviousYear',
                    secondaryMetricPropertyName: 'dealerAvgFormSubmissions',
                    secondaryMetricLabel: 'Dealer Avg',
                    secondaryMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    footerLeftLabel: 'MOM',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'formSubmissionsMOM',
                    metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    helpTextKey: 'WebsiteScorecardFormSubmissionsHelp',
                    helpTextTitle: 'Form Submissions',
                    scoreCardCategory: 'Actions'
                },
                {
                    title: 'Click to Calls',
                    subtitle: 'Previous MTD',
                    subtitleMetricPropertyName: 'clickToCallsPreviousMTD',
                    subtitleMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    iconClass: 'fa-phone fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'clickToCalls',
                    metricMOMPropertyName: 'clickToCallsMOM',
                    metricYOYPropertyName: 'clickToCallsYOY',
                    metricPreviousMonthPropertyName: 'clickToCallsPreviousMonth',
                    metricPreviousMTDPropertyName: 'clickToCallsPreviousMTD',
                    metricPreviousYearPropertyName: 'clickToCallsPreviousYear',
                    secondaryMetricPropertyName: 'dealerAvgClickToCalls',
                    secondaryMetricLabel: 'Dealer Avg',
                    secondaryMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    footerLeftLabel: 'MOM',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'clickToCallsMOM',
                    metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    helpTextKey: 'WebsiteScorecardClickToCallsHelp',
                    helpTextTitle: 'Click to Calls',
                    scoreCardCategory: 'Actions'
                },
                {
                    title: 'Call Tracking Volume',
                    subtitle: 'Previous MTD',
                    subtitleMetricPropertyName: 'phoneCallsPreviousMTD',
                    subtitleMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    iconClass: 'fa-phone fa-primary',
                    reverseMetric: false,
                    metricCurrentPropertyName: 'phoneCalls',
                    metricMOMPropertyName: 'phoneCallsMOM',
                    metricYOYPropertyName: 'phoneCallsYOY',
                    metricPreviousMonthPropertyName: 'phoneCallsPreviousMonth',
                    metricPreviousMTDPropertyName: 'phoneCallsPreviousMTD',
                    metricPreviousYearPropertyName: 'phoneCallsPreviousYear',
                    secondaryMetricPropertyName: 'dealerAvgPhoneCalls',
                    secondaryMetricLabel: 'Dealer Avg',
                    secondaryMetricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    footerLeftLabel: 'MOM',
                    footerRightLabel: 'YOY',
                    footerMetricFormatKey: constants.formatKeys.percentageTwoDecimals,
                    trendArrowDrivingPropertyName: 'phoneCallsMOM',
                    metricFormatKey: constants.formatKeys.abbreviatedLocaleString,
                    helpTextKey: 'WebsiteScorecardPhoneCallsHelp',
                    helpTextTitle: 'Call Tracking Volume',
                    scoreCardCategory: 'Actions'
                },
            ]
        }
    ];
}
